var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8094_13982",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 9L12 15L18 9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L12 15L18 9",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41421 7.58579C6.63317 6.80474 5.36683 6.80474 4.58579 7.58579C3.80474 8.36683 3.80474 9.63317 4.58579 10.4142L7.41421 7.58579ZM12 15L10.5858 16.4142C11.3668 17.1953 12.6332 17.1953 13.4142 16.4142L12 15ZM19.4142 10.4142C20.1953 9.63317 20.1953 8.36683 19.4142 7.58579C18.6332 6.80474 17.3668 6.80474 16.5858 7.58579L19.4142 10.4142ZM4.58579 10.4142L10.5858 16.4142L13.4142 13.5858L7.41421 7.58579L4.58579 10.4142ZM13.4142 16.4142L19.4142 10.4142L16.5858 7.58579L10.5858 13.5858L13.4142 16.4142Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_8094_13982)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhiteIcon);
export default __webpack_public_path__ + "static/media/arrow-down-white-icon.bbf68b70361c9ab18496fd0c4b85600f.svg";
export { ForwardRef as ReactComponent };